import { Divider, Flex, Skeleton, SkeletonCircle } from '@chakra-ui/react';
import { Fragment } from 'react';

const CommonLoadingCell = ({ rowHeight }: { rowHeight?: string }) => {
  return (
    <>
      <Flex
        p={4}
        bg="white"
        minH={rowHeight || '110px'}
        borderLeft="1px solid #E0E0E0"
      >
        <SkeletonCircle size="4" mr={2} />
        <Skeleton height="16px" width="80px" mb={1} />
      </Flex>
      <Divider />
    </>
  );
};

export default CommonLoadingCell;
